
import { Link } from 'react-router-dom';
import './App.css';
import '@fontsource/roboto/500.css';

function Header({data}) {
  return (
    <>
      <div className="container-fluid p-3">
        <div className="row justify-content-center">
          <div className="col-sm-1 col-md-1"></div>
          {/* <div className="col-sm-1 col-md-1"><img src="./../../../../assets/img/logo/logo.png" height={50} alt="Logo" /></div> */}
          <div className="col-sm-10 col-md-4 big">
              <img src="./../../../../assets/img/logo/logo.png" height={50} alt="Logo" />  &nbsp; &nbsp; <Link to="/" className='title-red' style={{ textDecoration: 'none' }}>LABOUR CHOWK ONLINE</Link> 
          </div>

          <div className="col-sm-12 col-md-5 big">
            +91 9717 800 805, 85100 35195, 78385 40774.
          </div>
          <div className="col-sm-12 col-md-2" style={{ textDecoration: 'none' }}>
                    <Link to="/" style={{ textDecoration: 'none' }} hidden={!data[0]}>Home {' '}</Link>  &nbsp;
                    <Link to="/Aboutus" style={{ textDecoration: 'none' }} hidden={!data[1]}>About Us </Link> {' '} &nbsp;
                    <Link to="/Contactus" style={{ textDecoration: 'none' }} hidden={!data[2]}>Contact Us</Link> {' '} &nbsp;
                    
          </div>
        </div>
      </div>
    </>
    );
}

export default Header;


